const PRIVACY_REVISION = 0;
const TERMS_REVISION = 0;

module.exports = {
    PRIVACY_REVISION,
    TERMS_REVISION
};
